import React, { Component } from 'react';
import { Polyline } from '@react-google-maps/api';

export default class AnimatingPolylineComponent extends Component {

  state = {
    polylinePath: this.props.direction,
  };

  componentDidMount() {
    this.animatePolyline();
  }

  animatePolyline = () => {
    this.interval = setInterval(() => this.animatePolylineStart(), 25);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  animatePolylineStart = () => {
    if (this.state.polylinePath.length < this.props.direction.length) {
      const Direction = this.props.direction;
      const polylinePath = [
        ...Direction.slice(0, this.state.polylinePath.length - 1)
      ];
      this.setState({polylinePath});
    } else {
      this.setState({polylinePath: []})
    }
  };

  render() {
    return (
      <>
        {
          (this.state.polylinePath.length > 0) && <Polyline
            path={this.state.polylinePath}
            options={{
              strokeColor: "#AAAEBD",
              strokeOpacity: 1.0,
              strokeWeight: 3.5,
            }}
          />
        }
      </>
    )
  }
}
